import React from 'react';

const EnergyCertificateGradeA = props => (
  <svg width="133" height="33" viewBox="0 0 133 33" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M0 -3.8147e-05V32.4791H116.618L132.987 16.1119L116.618 -3.8147e-05H0Z" fill="#3B7634" />
    <path
      d="M96.2701 18.6873H102.631L99.5376 8.81478H99.4681L96.2701 18.6873ZM93.1416 28.1442H87.6484L96.5465 3.18246H102.562L111.357 28.1442H105.692L104.091 22.9991H94.8779L93.1416 28.1442Z"
      fill="white"
    />
  </svg>
);

export default EnergyCertificateGradeA;
